import Modal from "react-bootstrap/Modal";
import React from "react";
import "./employeeAttendancePopUp.css";
import closeIcon from "../../../Asset/Images/close-for-logout.svg";
import pdfIcon from "../../../Asset/Images/pdf-icon.png";
import excelIcon from "../../../Asset/Images/excel-icon.png";
import strings from "../../../utils/property-file/employeeAttendance.json";
import { useState, useEffect, useRef, useContext } from "react";
import moment from "moment";
import Select from "react-select";
import appStylesSecond from "../../../utils/appStylesSecond";
import RangeCalendarPast from "../../rangeCalendar/rangeCalendarPast";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import constants from "../../../utils/constants";
import {  EmployeeAttendanceContext } from "../../employeeAttendance";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx"; 
import SpinnerButtonMedium from "../../button/SpinnerButtonMedium";
import PropTypes from "prop-types"

export default function EmployeeAttendanceReportPopUp(props) {
  const nav = useNavigate();
  const [calendar, showCalendar] = useState(false);
  const calendarRef = useRef();
  const [exportType, setExportType] = useState(null);
  const [selectEmployee, setSelectedEmployee] = useState(null);
  const [documentFormat , setDocumentFormat] = useState(null);
  const { setEmployeeAttendance } = useContext(
    EmployeeAttendanceContext
  );
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [pdfActive,setPDFActive] = useState("pdf-type-employee-attendance");
  const [excelActive,setExcelActive] = useState("excel-type-employee-attendance");
  const [fetchingData , setFetchingData] = useState(false);

  useEffect(()=>{
    if(documentFormat===strings.pdfLabel){
      setPDFActive("active-type-employee-attendance");
      setExcelActive("excel-type-employee-attendance");
    }
    else if(documentFormat===strings.excelLabel){
      setExcelActive("active-type-employee-attendance");
      setPDFActive("pdf-type-employee-attendance");
    }
    else {
      setPDFActive("pdf-type-employee-attendance");
      setExcelActive("excel-type-employee-attendance");
    }
  },[documentFormat])

  // This method is used for the calendar for range date selection
  const handleDateRangeSelection = (startDate, endDate) => {
    setSelectedStartDate(startDate ? startDate._d : null);
    setSelectedEndDate(endDate ? endDate._d : null);
  };

  // For the react-select the array creation in form of value and label
  let employeeNameArray = [];
  if (props.employeename.length > 0) {
    props.employeename.forEach((item) => {
        if (item.isActive) {
            const dataObject = {
                label: item.name,
                value: item._id,
            };
            employeeNameArray.push(dataObject);
        }
    });
}

  // Method for fetching data from api after selecting the employee name and date
  const fetchEmployeeAttendanceReport = async () => {
    try {
      setFetchingData(true);
      const response = await api.exportEmployeeAttendance(
        selectEmployee.value,
        moment(selectedStartDate).format(strings.yyyyMMDDFormat),
        selectedEndDate != null
          ? moment(selectedEndDate).format(strings.yyyyMMDDFormat)
          : moment(selectedStartDate).format(strings.yyyyMMDDFormat)
      );
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployeeAttendance(data.finalAttendanceList);
          if(documentFormat===strings.pdfLabel){ 
          localStorage.setItem(
            strings.selectedEmployeeName,
            selectEmployee.label
          );
          localStorage.setItem(
            strings.selectedEmpId,
            data.body
          );
          localStorage.setItem(
            strings.selectedEmployeeIdValue,
            selectEmployee.value
          );
          localStorage.setItem(strings.exportStartDate, selectedStartDate);
          localStorage.setItem(strings.exportEndDate, selectedEndDate);
          nav(constants.navigationLink.employeeAttendancePreview);
          }
          else{
            let excelSheetData=[];
            if (data.finalAttendanceList && data.finalAttendanceList.length > 0) {
            data.finalAttendanceList.forEach((item) => {
                const duration= item.SignIn!==strings.naLabel && item.SignOut!==strings.naLabel ?TimeDifferenceCalculator(moment(item.SignIn).format(strings.timeFormat),moment(item.SignOut).format(strings.timeFormat)):strings.naLabel
                const dataObject = {
                  'Emp Id': item.empId,
                  'Name': selectEmployee.label,
                  'Date' : moment(item.date).format(strings.ddMonthFormat),
                  'Check in': item.SignIn!==strings.naLabel ?moment(item.SignIn).format(strings.timeFormat) : strings.naLabel,
                  'Check out':item.SignOut!==strings.naLabel ? moment(item.SignOut).format(strings.timeFormat) : strings.naLabel,
                  'Duration': duration,
                  'Status': item.Status
                };
                excelSheetData.push(dataObject);
              });
            }
            exportExcel(excelSheetData,selectEmployee.label+"_"+strings.attendanceReportLabel)
          }
        } else {
          setEmployeeAttendance([]);
        }
        setFetchingData(false);
      }
    } catch (error) {
      setFetchingData(false);
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
    }
  };

  // For closing calender when user click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        showCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarRef]);

    // Extract time into Hours and minutes
    const parseTime = (timeString) => {
      const [hours, minutes] = timeString.split(':').map(Number);
      return hours * 60 + minutes;
    };
  
    // Calculation of time difference
    function TimeDifferenceCalculator( time1, time2 ) {
      const minutes1 = parseTime(time1);
      const minutes2 = parseTime(time2);
      const timeDifferenceInMinutes = minutes2 - minutes1;
      const hours = Math.floor(timeDifferenceInMinutes / 60);
      const remainingMinutes = timeDifferenceInMinutes % 60;
      return `${hours}h ${remainingMinutes}min`;
    }
    const fileType = strings.fileTypeString;
    const fileExtension = strings.xlsxFileExtension;
  const exportExcel = async (excelData,fileName) => {
    try {
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = { Sheets: { data: ws }, SheetNames: [strings.dataLabel] };
      const excelBuffer = XLSX.write(wb, { bookType: strings.xlsxLabel, type: strings.arrayLabel });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
      setExportType(null);
      setDocumentFormat(null);
      setSelectedEmployee(null);
      setSelectedStartDate(null);
      props.onHide();
      setEmployeeAttendance([]);
      toast.success(strings.reportExportedLabel , {toastId : strings.error6Label})
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel , {toastId : strings.error7Label});
    }
  };
  
  useEffect(()=>{
    setExportType(exportType);
    setDocumentFormat(documentFormat);
    setSelectedStartDate(selectedStartDate);
    setSelectedEmployee(selectEmployee);
  },[exportType,documentFormat,selectedStartDate,selectEmployee])

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="employee-level-attendance-report"
      >
        <div className="main-container-employee-attendance-report">
          <div className="name-of-pop-up">
            <div className="name-of-pop-up-data">
              {strings.employeeAttendanceLabel}
            </div>
            <div className="close-icon-emp-attendance">
              <img
                src={closeIcon}
                onClick={() => {
                  props.onHide();
                }}
                alt="close-icon"
                className="employee-pop-up-close"
              />
            </div>
          </div>
          <div className="select-employee-for-report">
            <Select
              className="emp-name-select-leave"
              options={employeeNameArray}
              styles={appStylesSecond.companyProfileDropdown}
              defaultValue={selectEmployee}
              onChange={(selectEmployee) => {
                setSelectedEmployee(selectEmployee);
              }}
              placeholder={strings.selectEmployeeLabel}
            />
          </div>
          <div className="date-type-selection">
            <div className="single-date-attendance">
              <input
                className="me-2 date-selection-for-report"
                type="radio"
                id="singleDate"
                name="date-selection"
                onClick={() => setExportType(strings.singleDateLabel)}
              />
              <label
                htmlFor="singleDate"
                className="date-selection-for-report"
                onClick={() => setExportType(strings.singleDateLabel)}
              >
                {strings.singleDate}
              </label>
            </div>
            <div className="multi-date-attendance">
              <input
                type="radio"
                className="me-2 date-selection-for-report"
                id="multi-date"
                name="date-selection"
                onClick={() => setExportType(strings.multiDateLabel)}
              />
              <label
                htmlFor="multi-date"
                className="date-selection-for-report"
                onClick={() => setExportType(strings.multiDateLabel)}
              >
                {strings.multiDate}
              </label>
            </div>
          </div>
          <div className="selected-dates-for-attendance" ref={calendarRef}>
            <input
              type="input"
              placeholder="Select Date *"
              disabled={exportType === null}
              value={
                selectedStartDate
                  ? selectedEndDate
                    ? moment(selectedStartDate).format(strings.ddMmFormat) +
                      " to " +
                      moment(selectedEndDate).format(strings.ddMmFormat)
                    : moment(selectedStartDate).format(strings.ddMmFormat)
                  : ""
              }
              onClick={() => {
                showCalendar(true);
              }}
            />
            {calendar && (
              <div className="date-selection-for-calender">
                <RangeCalendarPast
                  className="attendance-export-report-date-selection"
                  onDateRangeSelection={handleDateRangeSelection}
                  disableRange={exportType === strings.singleDateLabel}
                />
              </div>
            )}
          </div>
          <div className="format-choose-file mb-4">
            <div className={pdfActive} onClick={(()=>setDocumentFormat(strings.pdfLabel))}>
              <img src={pdfIcon} alt="pdf-icon" className="format-icons" />
            </div>
            <div className={excelActive}  onClick={(()=>setDocumentFormat(strings.excelLabel))}>
              <img src={excelIcon} alt="excel-icon" className="format-icons" />
            </div>
          </div>
          <div className="button-of-export-report">
            <button
              onClick={() => {
                fetchEmployeeAttendanceReport();
              }}
              disabled={selectEmployee===null || exportType ===null || selectedStartDate===null || documentFormat===null || fetchingData===true}
            >
            {fetchingData ? <SpinnerButtonMedium/>:strings.exportReportLabel}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

EmployeeAttendanceReportPopUp.propTypes = {
  employeename : PropTypes.any.isRequired,
  onHide : PropTypes.func.isRequired
}